export default "__VITE_ASSET___96XP3_j__"